import type { Session } from '#src/shared/session';

import type { FullAddressCollectionFiltersResult } from './fullAddressCollectionFilters';

type Params = {
	filters: FullAddressCollectionFiltersResult;
	loginState: Session['loginState'] | undefined;
};

export function isFullAddressCollectionEnabled({ filters, loginState }: Params): boolean {
	// This feature is disabled for IDENTIFIED users. For details see docs/front-end/pages/petitionDetails/sign-form.md
	if (!loginState || loginState === 'IDENTIFIED') {
		return false;
	}

	return isEnabledByFC(filters) && isEnabledForGeoReach(filters) && hasNonBlockedPoliticianDecisionMaker(filters);
}

function isEnabledByFC(filters: Params['filters']): boolean {
	return filters.petitionSignFormFullAddressCollection?.enabled === true;
}

function isEnabledForGeoReach(filters: Params['filters']): boolean {
	return filters.geoReach === 'local';
}

function hasNonBlockedPoliticianDecisionMaker(filters: Params['filters']): boolean {
	const decisionMakers = filters.dmsWithLegislativeBodiesConnection.nodes.flatMap((node) => node.decisionMakers);

	const blockedDecisionMakerIds = new Set(
		(filters.petitionSignFormFullAddressCollection?.decision_maker_blocklist ?? []).map((dm: { id: string }) => dm.id),
	);

	return decisionMakers.some((dm) => dm.type === 'POLITICIAN' && !blockedDecisionMakerIds.has(dm.id));
}
